module.exports = __webpack_public_path__ + "img/font-color.3cd513fe.svg";